import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {VoucherQuantityLimitExceededIcon} from 'assets/icons/voucherQuantityLimitExceededIcon';
import Button from 'components/button/Button';
import {useAppDispatch, useAppSelector} from 'hooks';
import {removePromotionVoucherAction} from 'store/actions/basket-action';

export type VoucherItemRemovedAlertContentProps = {
  onClose: () => void;
};

export const VoucherItemRemovedAlertContent = (props: VoucherItemRemovedAlertContentProps) => {
  const {onClose} = props;
  const {t} = useTranslation();
  const dispatch = useAppDispatch();
  const {details} = useAppSelector((state) => state.alert);

  const remove = () => {
    onClose();
    dispatch(
      removePromotionVoucherAction({
        callback: details?.callback
      })
    );
  };

  const keep = () => {
    onClose();
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box alignItems="center" width="100%" display="flex" flexDirection="column" gap={1} mb={2}>
        <VoucherQuantityLimitExceededIcon />
        <Typography fontSize={20} fontWeight={700} align="center">
          {t('alerts.voucherItemRemoved.title')}
        </Typography>
        <Box display="flex" alignItems="center" flexDirection="column">
          <Typography fontSize={16} align="center">
            {t('alerts.voucherItemRemoved.description')}
          </Typography>
        </Box>
      </Box>
      <Button onClick={remove} shape="rounded" variant="contained">
        {t('alerts.voucherItemRemoved.remove')}
      </Button>
      <Button onClick={keep} shape="rounded" variant="outlined">
        {t('alerts.voucherItemRemoved.keep')}
      </Button>
    </Box>
  );
};
